import { useState, useEffect } from "react";

export interface Notification {
  id: string;
  title: string;
  description?: string;
  variant?: "default" | "destructive";
  timestamp: number;
  read: boolean;
}

let notifications: Notification[] = [];
let idCounter = 0;
const storeListeners: Array<(n: Notification[]) => void> = [];

function notify() {
  storeListeners.forEach((fn) => fn([...notifications]));
}

export function addNotification(opts: { title: string; description?: string; variant?: "default" | "destructive" }) {
  idCounter++;
  notifications = [
    {
      id: String(idCounter),
      title: opts.title,
      description: opts.description,
      variant: opts.variant,
      timestamp: Date.now(),
      read: false,
    },
    ...notifications,
  ];
  notify();
}

export function markAllRead() {
  notifications = notifications.map((n) => ({ ...n, read: true }));
  notify();
}

export function clearNotifications() {
  notifications = [];
  notify();
}

export function useNotifications() {
  const [state, setState] = useState<Notification[]>(notifications);

  useEffect(() => {
    storeListeners.push(setState);
    return () => {
      const idx = storeListeners.indexOf(setState);
      if (idx > -1) storeListeners.splice(idx, 1);
    };
  }, []);

  const unreadCount = state.filter((n) => !n.read).length;

  return { notifications: state, unreadCount, markAllRead, clearNotifications };
}
